/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { Action, Column, Options } from '@infotrack/presentacion-componentes/tabla';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import ITiposBodegas from 'Infotrack@Modelos/smartStock/tiposBodegas/entidades/tiposBodegas';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const columnas = (
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string
): Array<Column<ITiposBodegas>> => [
    {
        title: formatMessage({ id: 'tiposBodegas.tipoBodegaDescripcion' }),
        field: 'TipoBodegaDescripcion',
    },
    {
        title: formatMessage({ id: 'productos.estado' }),
        field: 'Estado',
        type: 'boolean',
    },
];

export const acciones = (
    manejarFormulario: (tipoFormulario: TipoFormulario, tiposBodegas?: ITiposBodegas) => void,
    cargarTiposBodegas: () => void,
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string,
    confirmarEliminacion: (tiposBodegas: ITiposBodegas) => void
): Array<Action<ITiposBodegas>> => [
    {
        icon: 'refresh',
        onClick: cargarTiposBodegas,
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.refrescar' }),
    },
    {
        icon: 'add',
        onClick: () => manejarFormulario(TipoFormulario.Creacion, undefined),
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.agregar' }),
    },
    {
        icon: () => <EditIcon id="Icono-Editar" color="action" />,
        onClick: (_, value) => manejarFormulario(TipoFormulario.Edicion, value as ITiposBodegas),
        tooltip: formatMessage({ id: 'boton.editar' }),
    },
    {
        icon: () => <DeleteIcon id="Icono-Eliminar" color="action" />,
        onClick: (_, value) => confirmarEliminacion(value as ITiposBodegas),
        tooltip: formatMessage({ id: 'boton.eliminar' }),
    },
];

export const opciones: Options<ITiposBodegas> = {
    maxBodyHeight: '50vh',
};
